import React from 'react';
import PropTypes from 'prop-types';
import {Header as MastheadHeader} from '@spotify-internal/masthead-react';

import {SPOTIFYCOM_URL, SUPPORT_SITE_URL} from 'lib/shared/config/config';
import {withConfig} from 'context/Config/ConfigProvider';
import {configPropType} from 'utils/custom-proptypes';

const PLAIN_HEADER = {
  navigation: {
    brand: {
      href: SPOTIFYCOM_URL,
      alt: 'Spotify',
    },
  },
};

const Header = ({headerData, config}) => {
  const data = !headerData || config.plainUI ? PLAIN_HEADER : headerData;

  // Multi lang banners have direct link to www, for now we manually replace it for ours
  // TODO: replace once this is doable through Masthead config or dyl
  if (data.messageBars) {
    data.messageBars = data.messageBars.map(messageBar => {
      if (!messageBar.options || messageBar.options.type !== 'multiLanguage') {
        return messageBar;
      }
      return {
        ...messageBar,
        messageHTML: messageBar.messageHTML.replace(SPOTIFYCOM_URL, SUPPORT_SITE_URL),
      };
    });
  }

  return <MastheadHeader {...data} transparent={false} fixed={false} />;
};

Header.propTypes = {
  headerData: PropTypes.object,
  config: configPropType,
};

export default withConfig(Header);
